<template>
  <div>
    <v-dialog title="공동인증서" v-model="certificateDialog" persistent max-width="460px" width="460px" class="noShadow">
      <div id="wrap">
        <form id="pubCertForm" ref="pubCertForm" target="pubCertFrame" :action="certURL + subURL">
          <input type = "hidden"  name="verifyData" :value="verifyData"/>
        </form>
        <iframe
          width="100%"
          name="pubCertFrame"
          height="650px"
          style="border:none">
        </iframe>
      </div>
    </v-dialog>
    <s-loading ref="loading"></s-loading>
    <s-confirm ref="confirm"></s-confirm>
  </div>
</template>
<script>
export default {
  name: 'pubCertCompany',
  components: {
  },
  filters: {
  },
  props:{
    certRegno: String,
  },
  data () {
    return {
      // 상세 다이얼로그
      certificateDialog: false,
      certURL: process.env.VUE_APP_URL_AUTH,
      subURL: '/pubCertificate/company',
      sign: null,
      vid: null,
      // 인증서 타입: 개인: 1 / 기업 2
      verifyType: '2',
      // 인증서 신원검증데이터: 개인: 본인이름 / 기업: 사업자번호
      verifyData:''
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    open() {
      this.certificateDialog = true
      this.verifyData = btoa(encodeURIComponent(this.certRegno))
      setTimeout(this.pubOpen, 1000);
    },
    close () {
      this.certificateDialog = false
    },
    pubOpen () {
      this.$nextTick(() => {
        window.addEventListener('message', this.pubCertResult, true)

        this.$refs.pubCertForm.submit()
      })
    },
    pubCertResult (result) {
      var data = result.data
      this.$nextTick(() => {
        this.certificateDialog = false
        if (data.errorCode === '0000') {
          this.$emit('childs-event', data.result)
        } else if(data.errorCode === '366411776') {
          this.$refs.confirm.open('alert', '공동인증서 인증 실패', '공동인증서 정보가 신원검증에 실패하였습니다. 주민등록번호 혹은 사업자번호가 올바르게 입력되었는지 확인하십시오.' )
        }else{
          this.$refs.confirm.open('alert', '공동인증서 인증 실패', '공동인증서 정보가 신원검증에 실패하였습니다. 메시지가 지속되면 관리자에게 문의해주세요.' )
        }
      })
    }
  }
}
</script>
